import React from 'react';
import Tabs from '@/finsight/ui/common/components/Tabs';

import styles from './listTabs.scss';

interface ITab {
  name: string,
  key: string | number,
  isDisabled: boolean,
}

interface IProps {
  lists: ITab[],
  selectedTab: string,
  onChange: (name: string) => void,
}

const ListTabs = ({ lists, selectedTab, onChange }: IProps) => (
  <div className={ styles.tabsContainer }>
    <Tabs tabs={ lists } activeTab={ selectedTab } onSelect={ onChange } dataTest="portfolioMonitorListTabs" />
  </div>
);

export default ListTabs;
